import React, { useEffect, useState } from "react";
import { Table, Label } from "semantic-ui-react";
import "./Tvview.css";
import { useAtom } from "jotai";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { useItemsFilter } from "../../../_helper/actions/app/items";
// import { removeSpacesAndConvertToUppercase } from "../../../_helper/utils/utils";

export default function BookedSlotsTable({ data, tvViewPermissions }) {
  const [clinic] = useAtom(clinicAtom);
  const [Data, setData] = useState([]);

  useEffect(() => {
    if (tvViewPermissions?.length > 0 && data?.length > 0) {
      const { fields } = tvViewPermissions[0];
      const modifiedData = data.map((item) => {
        const modifiedItem = {};
        fields.forEach((permission) => {
          if (permission.checked) {
            modifiedItem[permission.name] = item[permission.name];
          }
        });
        return modifiedItem;
      });
      setData(modifiedData);
    }
  }, [tvViewPermissions, data]);

  return (
    <div
      className="table-container"
      style={{
        overflow: "hidden",
        background: "white",
        margin: "0 10px 0 10px",
      }}
    >
      <Table compact="very" textAlign="center">
        <Table.Header
          fullWidth
          style={{
            backgroundColor: "#fbfbfb",
            zIndex: 100,
            position: "sticky",
          }}
        >
          <Table.Row
            style={{
              backgroundColor: "#fbfbfb",
              color: "white",
              padding: "0px",
              // border: "1px solid red",
            }}
          >
            {Data?.length > 0 &&
              Object.keys(Data[0])?.map((col) => (
                <Table.HeaderCell
                  key={col}
                  style={{
                    // backgroundColor: "#fbfbfb",
                    color: "black",
                    padding: "5px",
                    backgroundColor: "white",
                  }}
                >
                  {col.split("_").join(" ")}
                </Table.HeaderCell>
              ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Data?.length > 0 && Data[0] && (
            <Table.Row
              style={{
                zIndex: 101,
                position: "relative",
                backgroundColor: "#f9fafb",
                height: "2px !important",
              }}
              className="book-table-font"
            >
              {Object.keys(Data[0])?.map((key, i) => {
                if (i === 0) {
                  return (
                    <Table.Cell
                      key={i}
                      className="book-table-font-td"
                      style={{
                        // backgroundColor: "#9dfcac",
                        color: "#000",
                        padding: "3px",
                        // border: "1px solid red",
                        width: "290px",
                      }}
                      textAlign="center"
                    >
                      <div className="border absolute left-3 bg-[#9dfcac] w-5 h-5 rounded-full"></div>
                      {Data[0][key]}
                    </Table.Cell>
                  );
                } else {
                  return (
                    <Table.Cell
                      key={i}
                      className="book-table-font-td"
                      style={{ padding: "3px" }}
                    >
                      {Data[0][key]}
                    </Table.Cell>
                  );
                }
              })}
            </Table.Row>
          )}
          {Data?.length > 0 && Data[1] && (
            <Table.Row
              style={{
                zIndex: 101,
                position: "relative",
                backgroundColor: "#f9fafb",
                textAlign: "center",
              }}
              className="book-table-font"
            >
              {Object.keys(Data[1])?.map((key, i) => {
                if (i === 0) {
                  return (
                    <Table.Cell
                      key={i}
                      className="book-table-font-td"
                      textAlign="center"
                      style={{
                        // backgroundColor: "#ffce5e",
                        color: "#000",
                        borderBottom: "1px solid #e8e8e8",
                        padding: "3px",
                      }}
                    >
                      {/* <Label
                        ribbon
                      >{`\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Next Patient`}</Label> */}
                      <div className="border absolute left-3 bg-[#ffce5e] w-5 h-5 rounded-full"></div>
                      {`${Data[1][key]}`}
                    </Table.Cell>
                  );
                } else {
                  return (
                    <Table.Cell
                      key={i}
                      className="book-table-font-td"
                      style={{
                        borderBottom: "1px solid #e8e8e8",
                        padding: "3px",
                      }}
                    >
                      {Data[1][key]}
                    </Table.Cell>
                  );
                }
              })}
            </Table.Row>
          )}
        </Table.Body>
        {Data?.length > 2 && (
          <Table.Body className={Data?.length > 5 ? "roll-up-table" : ""}>
            {Data?.map((ele, index) => {
              if (index > 1) {
                return (
                  <Table.Row
                    key={index}
                    className="book-table-font roll-up-table"
                  >
                    {Object.keys(ele)?.map((key) => (
                      <Table.Cell
                        key={key}
                        className="book-table-font-td"
                        style={{
                          borderBottom:
                            index === Data?.length - 1
                              ? "1px solid #e8e8e8"
                              : "none",
                          padding: "3px",
                        }}
                      >
                        {ele[key]}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                );
              }
            })}
          </Table.Body>
        )}
      </Table>
    </div>
  );
}
